import React from 'react'
import type { Card } from '../types/LessonDoc'
import { getCardDef } from '../cards/registry'

// Đường render DUY NHẤT cho một thẻ — dùng cho cả xem trước (builder)
// và trang học công khai (Phase F). Mỗi thẻ tự render qua Preview của nó.
// onComplete (tuỳ chọn): chuyển xuống Preview để lộ trình "vượt ải" biết khi thẻ hoàn thành.
const LessonCardRenderer: React.FC<{ card: Card; onComplete?: () => void }> = ({ card, onComplete }) => {
  const def = getCardDef(card.type)
  if (!def) {
    return (
      <div className="p-3 rounded-lg bg-yellow-50 border border-yellow-200 text-yellow-800 text-sm">
        Không nhận diện được loại thẻ: {card.type}
      </div>
    )
  }
  const Preview = def.Preview
  return (
    <div className="lesson-card">
      {card.title && <h3 className="text-base font-bold text-blue-900 mb-2">{card.title}</h3>}
      <Preview card={card} onComplete={onComplete} />
    </div>
  )
}

export default LessonCardRenderer
